<div class="row body-2 grey-text mb-2">
    <div class="col-3 text-center">
        {{donation.amount | currency:'USD':'symbol-narrow':'1.0-0'}}
    </div>
    <div class="col-3 text-center">
        {{updated | activityTimer:index}}
    </div>
</div>